import logoAppGallop from './images/logo_appgallop.png';

export function Logo({ className = '' }: { className?: string }) {
  return (
    <div className={`flex items-center gap-2 group cursor-pointer ${className}`}>
      <img 
        src={logoAppGallop}
        alt="AppGallop Logo" 
        className="h-8 md:h-10 object-contain"
      />
    </div>
  );
}
